import "leaflet";
import {state, resetState} from "./state";
import {initMap} from "./map";
import {initListener, loadPoints, updateEmptyOverlayState, deleteMarker} from "./markers";
import {initUI} from "./ui";
import {initDragListeners} from "./paths";
import {
    loadAnimatedImages,
    enableAssetDragToMap,
    confirmAnimatedImageCreated,
    deleteAnimatedImage, updateAnimatedImage
} from "./animated-images";
import {api} from "../../core/api";
import {createIcon} from "./icons.js";

export function init(parent) {
    const el = parent.querySelector('#map-adventure');
    if (!el)
        return;

    resetState();
    state.mapId = el.dataset.mapId;
    const points = JSON.parse(document.getElementById("points-data").textContent);
    const mapImage = JSON.parse(document.getElementById("map-image").textContent);
    const animatedImages = JSON.parse(
        document.getElementById("animated-images-data").textContent
    );

    state.markersGroup = L.layerGroup();
    state.pathsGroup = L.layerGroup();

    initMap({mapImage});

    state.markersGroup.addTo(state.map);
    state.pathsGroup.addTo(state.map);

    state.animatedImagesGroup = L.layerGroup().addTo(state.map);
    loadAnimatedImages(animatedImages);
    enableAssetDragToMap();

    initUI();
    loadPoints(points);
    updateEmptyOverlayState();
    //initCreatePointInteractions();
    initDragListeners();
    initListener();

    el.addEventListener('map:update-handlers', async function (evt) {
        const pointId = evt.detail.point.id;
        await api.put(
            CONFIG.urls.updatePointHandlers.replace('/0/', `/${pointId}/`),
            {
                handlers: Object.values(evt.detail.handlers)
            }
        );
    });

    el.addEventListener('map:move-point', async function (evt) {
        const {id, lat, lng} = evt.detail;
        await api.put(
            CONFIG.urls.updatePointPosition.replace('/0/', `/${id}/`),
            {
                lat: lat,
                lng: lng
            }
        );
    });

    el.addEventListener('map:create-animated-image', async evt => {
        const {tmpId, asset, lat, lng} = evt.detail;

        const res = await api.post(
            CONFIG.urls.mapPropCreate.replace('/0/', `/${state.mapId}/`),
            {asset, lat, lng}
        );

        confirmAnimatedImageCreated(tmpId, res.data);
    });

    el.addEventListener('map:move-animated-image', async evt => {
        const {id, lat, lng} = evt.detail;

        await api.patch(
            CONFIG.urls.mapPropPositionUpdate.replace('/0/', `/${id}/`),
            {lat, lng}
        );
    });

    el.addEventListener('map:delete-point', async evt => {
        const point = evt.detail;
        try {
            const response = await api.delete(CONFIG.urls.deletePointAdventure.replace('/0/', `/${point.id}/`));

            if (response.status === 204) {
                deleteMarker(point.id);
            } else {
                htmx.trigger(document, 'toast:add', {
                    message: 'Impossible de supprimer le point.', type: "danger"
                });
            }
        } catch (err) {
            htmx.trigger(document, 'toast:add', {
                message: 'Impossible de supprimer le point.', type: "danger"
            });
        }
    });

    el.addEventListener('map:delete-animated-image', async evt => {
        const {id} = evt.detail;

        await api.delete(
            CONFIG.urls.mapPropDelete.replace('/0/', `/${id}/`)
        );
    });

    document.addEventListener('map:delete-asset', evt => {
        deleteAnimatedImage(evt.detail.id);
    });

    document.addEventListener('map:update-asset', evt => {
        updateAnimatedImage(evt.detail);
    });


    document.body.addEventListener("map:point-updated", (evt) => {
        const updatedPoint = evt.detail;
        const marker = state.markers[updatedPoint.id];
        if (!marker) return;

        // --------------------------------------------------
        // UPDATE DU MODÈLE
        // --------------------------------------------------
        marker.options.point = updatedPoint;

        // --------------------------------------------------
        // UPDATE DU TOOLTIP
        // --------------------------------------------------
        if (marker.options.point.title) {
            marker.bindTooltip(marker.options.point.title, {
                direction: "top",
                offset: [0, -20],
                className: "map-tooltip"
            });
        } else {
            marker.unbindTooltip();
        }

        // --------------------------------------------------
        // UPDATE DE L’ICÔNE
        // --------------------------------------------------
        marker.setIcon(createIcon(marker.options.point));
    });

}
